import { PERMISSION_KEYS as P } from "./permissionKeys";

/**
 * Maps GET /users/me `role.permissions[]` codes (API: SCREAMING_SNAKE) to app keys
 * ({@link ./permissionKeys.js} string values, or an array to grant several keys at once).
 * Multiple codes may grant the same app key.
 */
export const API_PERMISSION_CODE_TO_APP_KEY = Object.freeze({
  // Dashboard
  DASHBOARD_VIEW: P.DASHBOARD_VIEW,

  // Billing / tags / settings
  BILLING_VIEW: P.BILLING_VIEW,
  SAAS_BILLING_VIEW: P.SAAS_BILLING_VIEW,
  SAAS_BILLING_EXPORT: P.SAAS_BILLING_EXPORT,
  QB_BILLING_VIEW: P.QB_BILLING_VIEW,
  QB_BILLING_EXPORT: P.QB_BILLING_EXPORT,
  /** @deprecated Pre-rename API codes — same app keys as above */
  BILLING_SAAS_EXPORT_VIEW: P.SAAS_BILLING_VIEW,
  BILLING_SAAS_EXPORT_RUN: P.SAAS_BILLING_EXPORT,
  BILLING_QB_EXPORT_VIEW: P.QB_BILLING_VIEW,
  BILLING_QB_EXPORT_RUN: P.QB_BILLING_EXPORT,
  BILLING_QB_EXPORT_GENERATE: P.QB_BILLING_EXPORT,
  SETTINGS_ROLE_PERMISSION: P.SETTINGS_ROLE_PERMISSION,
  TAGS_VIEW: P.TAGS_VIEW,
  TAG_MAPPING_MANAGE: P.TAGS_VIEW,
  SYSTEM_LIST_ADD: P.SYSTEM_LIST_ADD,
  SYSTEM_LIST_EDIT: P.SYSTEM_LIST_EDIT,
  SYSTEM_LIST_DELETE: P.SYSTEM_LIST_DELETE,
  SAAS_MODULE_ADD: P.SAAS_MODULE_ADD,
  SAAS_MODULE_EDIT: P.SAAS_MODULE_EDIT,
  SAAS_MODULE_DELETE: P.SAAS_MODULE_DELETE,
  PROJECTS_SETTINGS_MANAGE: P.PROJECTS_SETTINGS_MANAGE,

  // Users
  USER_VIEW: P.USERS_VIEW,
  USER_CREATE: P.USERS_CREATE,
  ADMIN_USER_CREATE: P.USERS_CREATE,
  USER_UPDATE: P.USERS_EDIT,
  USER_DELETE: P.USERS_DELETE,

  // Clients — CLIENT_VIEW_ALL grants list access only; sidebar uses CLIENTS_SIDEBAR (CLIENT_VIEW only).
  CLIENT_VIEW: [P.CLIENT_VIEW, P.CLIENTS_SIDEBAR],
  CLIENT_VIEW_ALL: P.CLIENT_VIEW,
  CLIENT_DASHBOARD_VIEW: P.CLIENTS_DASHBOARD_VIEW,
  CLIENT_CREATE: P.CLIENTS_CREATE,
  CLIENT_UPDATE: P.CLIENTS_EDIT,
  CLIENT_DELETE: P.CLIENTS_DELETE,

  // Teams
  TEAMS_VIEW: P.TEAMS_VIEW,
  TEAMS_CREATE: P.TEAMS_CREATE,
  TEAMS_EDIT: P.TEAMS_EDIT,
  TEAMS_DELETE: P.TEAMS_DELETE,
  TEAMS_ADD_MEMBER: P.TEAMS_ADD_MEMBER,

  // Projects — PROJECT_VIEW_ALL grants list access only; sidebar uses PROJECTS_SIDEBAR (PROJECT_VIEW only).
  PROJECT_VIEW: [P.PROJECTS_VIEW, P.PROJECTS_SIDEBAR],
  PROJECT_VIEW_ALL: P.PROJECTS_VIEW,
  PROJECT_DASHBOARD_VIEW: P.PROJECTS_DASHBOARD_VIEW,
  PROJECTS_DASHBOARD_VIEW: P.PROJECTS_DASHBOARD_VIEW,
  PROJECT_CREATE: P.PROJECTS_CREATE,
  PROJECT_UPDATE: P.PROJECTS_EDIT,
  PROJECT_DELETE: P.PROJECTS_DELETE,

  // Work items (issues / tasks)
  WORK_ITEM_VIEW: P.WORK_ITEMS_VIEW,
  WORK_ITEMS_VIEW: P.WORK_ITEMS_VIEW,
  KANBAN_VIEW: P.KANBAN_VIEW,
  MY_WORK_ITEMS_VIEW: P.MY_WORK_ITEMS_VIEW,
  WORK_ITEMS_CREATE: P.WORK_ITEMS_CREATE,
  WORK_ITEMS_EDIT: P.WORK_ITEMS_EDIT,
  WORK_ITEMS_DELETE: P.WORK_ITEMS_DELETE,

  // Time entry
  TIME_ENTRY_TIMESHEET_VIEW: P.TIME_ENTRY_TIMESHEET_VIEW,
  ALL_TIME_ENTRY_TIMESHEET_VIEW: P.ALL_TIME_ENTRY_TIMESHEET_VIEW,
  TIME_ENTRY_TEAM_SUMMARY_VIEW: P.TIME_ENTRY_TEAM_SUMMARY_VIEW,
  TIME_ENTRY_PROJECT_SUMMARY_VIEW: P.TIME_ENTRY_PROJECT_SUMMARY_VIEW,
  TIME_ENTRY_CREATE: P.TIME_ENTRY_CREATE,
  TIME_ENTRY_EDIT: P.TIME_ENTRY_EDIT,
  TIME_ENTRY_DELETE: P.TIME_ENTRY_DELETE,

  // Reports — month locking & audit
  REPORTS_LOCK_AUDIT_VIEW: P.REPORTS_LOCK_AUDIT_VIEW,
  MONTH_LOCK_MANAGE: P.MONTH_LOCK_MANAGE,
  MONTH_LOCK_UNLOCK: P.MONTH_LOCK_UNLOCK,
  /** Legacy / alternate API name — same access as month locking & audit page. */
  REPORTS_AUDIT_VIEW: P.REPORTS_LOCK_AUDIT_VIEW,
  REPORTS_AUDIT_EXPORT: P.REPORTS_AUDIT_EXPORT,
});

/** @param {unknown} code */
export function normalizeApiPermissionCode(code) {
  if (code == null) return "";
  return String(code).trim().toUpperCase();
}
